import React from 'react'
import './BlogCard.scss'

const BlogCard = ({img, heading, para}) => {
    return (
        <div className='blog-lowerGrid-box'>
            <div className='blog-lowerGrid-imgBox'>
                <img src={img} alt='' />
            </div>
            <p>By <span>John Doe</span>   l   Aug 07, 2021 </p>
            <h5>{heading}</h5>
            <p>{para} </p>
        </div>
    )
}

export default BlogCard